export default {
  common: {
    pleaseEnterSearchKeywords: "Please enter search keywords"
  },
  outputProjectList: {
    dateofRegistration: "Date of registration",
    updateDate: "Update time",
    projectName: "Project name",
    dateofAudit: "Date of audit (year-month)",
    customerName: "Customer name",
    customerEmail: "Customer Email",
    address: "Address",
    zone: "Zone",
    city: "City",
    submiter: "Submitter",
    projectStatus: "Project status",
    estimateEcmQutedAmount: "Estimated ECM quoted amount (USD)",
    expectedOrder: "Expected order (month/year)",
    actualEcmQutedAmount: "Actual ECM quoted amount (USD)",
    actualOrder: "Actual order (month/year)",
    winProbability: "Win probability",
    statusRemarks: "Project remarks",
    lastUpdateDate: "Last update date"
  },
  outputAccountList: {
    activate: "Activate",
    registerDate: "Register Date",
    lastLoginDate: "Last Login Date"
  },
  nomenclature: {
    row0_1: "Term",
    row0_2: "Definition",
    row1_1: "AC",
    row1_2: "Air-cooled.",
    row2_1: "AHRI",
    row2_2: "Air-Conditioning, Heating, and Refrigeration Institute — the U.S. industry body that certifies chiller performance ratings used in eCAT selections.",
    row3_1: "Air-Cooled Chiller",
    row3_2: "A chiller that rejects heat directly to ambient air via condenser fans and does not require cooling towers or condenser water pumps.",
    row4_1: "Approach Temperature",
    row4_2:
      "The temperature difference between the cooling tower leaving water temperature and the entering wet bulb temperature; default 3 °C in iECM and a key parameter for condenser water modelling.",
    row5_1: "ASIA",
    row5_2: "Asia Region Portfolio. The manufacturing portfolio used for Carrier chillers primarily released in Asia.",
    row6_1: "Baseline",
    row6_2: "The current chiller system used as the comparison benchmark.",
    row7_1: "Build Vertical",
    row7_2: "The building type classification selected during project setup, such as Office, Hotel, Hospital, or Others; it may influence default assumptions.",
    row8_1: "CAPEX",
    row8_2: "Capital expenditure; the upfront investment cost of the retrofit project.",
    row9_1: "Carbon Intensity of Electricity",
    row9_2: "The mass of CO₂ equivalent emitted per unit of electricity consumed; the iECM default is 0.707 kgCO₂e/kWh, though the value varies by region and grid energy mix.",
    row10_1: "Centrifugal Chiller",
    row10_2: 'A chiller type that uses a centrifugal compressor and is commonly used in large commercial and industrial applications; it is referenced as "WC–Centri" in iECM.',
    row11_1: "Chilled Water",
    row11_2: "Water cooled by the chiller and circulated through the building's air-handling system to provide space cooling.",
    row12_1: "CHW",
    row12_2: "Chilled water.",
    row13_1: "CHWP",
    row13_2: "Chilled water pump.",
    row14_1: "Cluster",
    row14_2: "A group of months with similar operating or weather conditions used in simulation.",
    row15_1: "Comfort Cooling",
    row15_2: "Cooling provided for occupant thermal comfort in buildings, such as offices and hotels; it is distinct from process cooling.",
    row16_1: "Common Header",
    row16_2: "A condenser water piping arrangement where all chillers share a single supply and return header, allowing any cooling tower to serve any chiller.",
    row17_1: "Condenser Water",
    row17_2: "Water circulated between the chiller condenser and the cooling tower to reject heat from the refrigeration cycle.",
    row18_1: "COP",
    row18_2: "Coefficient of performance.",
    row19_1: "CT",
    row19_2: "Cooling tower.",
    row20_1: "CWP",
    row20_2: "Condenser water pump.",
    row21_1: "CWS",
    row21_2: "Condenser water supply.",
    row22_1: "DB",
    row22_2: "Electrical distribution board.",
    row23_1: "Degradation Rate",
    row23_2:
      "The annual percentage decline in chiller efficiency due to aging, fouling, and wear; typical assumptions are 0.25% for Good, 0.50% for Average, 0.75% for Below Average, and 1.00% for Bad.",
    row24_1: "Digital e-CAT",
    row24_2: "A physics-based and data-driven modelling tool that predicts chiller performance.",
    row25_1: "Discount Rate",
    row25_2: "The interest rate used to calculate the present value of future cash flows in NPV analysis; the iECM default is 3%.",
    row26_1: "Dry Bulb Temperature",
    row26_2: "The ambient air temperature measured by a standard thermometer, unaffected by moisture; it is used in iECM weather profiles for air-cooled chiller modelling and cluster settings.",
    row27_1: "e-CAT library",
    row27_2: "The official Carrier e-CAT chiller database available to all users.",
    row28_1: "EA",
    row28_2: "Energy audit.",
    row29_1: "EA Report",
    row29_2: "Energy Audit Report — the baseline report generated at the end of the baseline preview step, documenting current system performance and improvement opportunities.",
    row30_1: "eCAT",
    row30_2: "Carrier electronic catalog and chiller selection software.",
    row31_1: "ECM",
    row31_2: "Energy Conservation Measure; a proposed efficiency improvement action.",
    row32_1: "ECM Report",
    row32_2: "Energy Conservation Measure Report — the proposal document containing the recommended solution, energy savings, financial analysis, and business case.",
    row33_1: "EER",
    row33_2: "Energy efficiency ratio.",
    row34_1: "EMEA",
    row34_2: "Europe, Middle East and Africa. The manufacturing portfolio used for Carrier chillers released in Europe, the Middle East, and Africa.",
    row35_1: "Escalation Rate",
    row35_2: "The assumed annual percentage increase in operating costs such as energy, maintenance, repair, and others; the iECM default is 2% per year.",
    row36_1: "Estimated e-CAT",
    row36_2: "Performance data estimated by the digital e-CAT algorithm when standard e-CAT data is unavailable.",
    row37_1: "FX rate",
    row37_2: "Foreign exchange rate.",
    row38_1: "Hz",
    row38_2: "Hertz — the unit of frequency; it is used in iECM to define pump and cooling tower fan VFD operating limits.",
    row39_1: "iECM",
    row39_2: "Intelligent Energy Conservation Measure; Carrier’s energy audit and retrofit analysis tool for chiller plant optimization.",
    row40_1: "Incentives & Rebates",
    row40_2: "Government or utility financial incentives factored into the NPV calculation on a year-by-year basis for up to 19 years.",
    row41_1: "kgCO₂e",
    row41_2: "Kilograms of carbon dioxide equivalent — the unit used to express greenhouse gas emissions associated with electricity consumption.",
    row42_1: "kW",
    row42_2: "Kilowatt — a unit of electrical power equal to 1,000 watts.",
    row43_1: "kWc",
    row43_2: "Kilowatt cooling — the cooling output power of a chiller or plant, measured in kilowatts.",
    row44_1: "kWe",
    row44_2: "Input kilowatt electrical — the electrical power consumed by a chiller or plant component.",
    row45_1: "kWh",
    row45_2: "Kilowatt-hour — a unit of energy consumption equal to 1 kW sustained for 1 hour.",
    row46_1: "kWh/RTh",
    row46_2: "Kilowatt-hours per refrigeration ton-hour; a plant efficiency metric.",
    row47_1: "Manufacturing Region/Source",
    row47_2:
      "The regional Carrier manufacturing portfolio used to determine the supported chiller model library (ASIA, EMEA, or NAO). The same chiller family may be available in more than one region.",
    row48_1: "Multi-point Input",
    row48_2: "An iECM data entry feature that copies the current month’s value to all subsequent months, accelerating repetitive data entry without overwriting previously entered values.",
    row49_1: "NAO",
    row49_2: "North America Operations. The manufacturing portfolio used for Carrier chillers released through North America Operations.",
    row50_1: "NPV",
    row50_2: "Net Present Value; the present value of future project cash flows.",
    row51_1: "Off-peak",
    row51_2: "Overall monthly mean temperature. Represents the averaged part of the day — used to weight night off-peak period allocation.",
    row52_1: "Operating Period",
    row52_2: "The day-type classification used in monthly baseline modelling — Weekday, Weekend, or Whole Period — to capture different usage patterns.",
    row53_1: "Operating Site Chiller",
    row53_2:
      "A site chiller selected to represent the primary chiller operating during a specific load period (such as peak or off-peak). The selected chiller is used as the reference equipment for baseline performance modelling and proxy chiller selection.",
    row54_1: "Own library",
    row54_2: "A personal library containing user-uploaded or user-managed chiller data.",
    row55_1: "Part-load",
    row55_2: "Operation below full rated capacity.",
    row56_1: "Payback Period",
    row56_2: "The number of years required for cumulative annual savings to equal the total CAPEX investment.",
    row57_1: "Peak",
    row57_2: "Average of daily maximum temperatures per month. Represents the hottest part of the day — used to weight daytime peak period allocation.",
    row58_1: "Peak / Off-peak in Tariff",
    row58_2: "Time-of-use electricity pricing periods in which peak hours have higher tariff rates and off-peak hours have lower tariff rates.",
    row59_1: "Plant Control System",
    row59_2: "The automation and control infrastructure, including sensors, controllers, and BMS integration, used to optimize proposed chiller plant operation; it is included as a CAPEX line item.",
    row60_1: "PLR",
    row60_2: "Part load ratio.",
    row61_1: "Primary System",
    row61_2: "A chilled water piping configuration in which a single set of pumps circulates water through both the chillers and the building distribution loop.",
    row62_1: "Primary–Secondary System",
    row62_2:
      "A chilled water piping configuration with separate pump sets: primary pumps serve the chillers, while secondary pumps serve the building distribution loop, enabling independent flow control.",
    row63_1: "Process Cooling",
    row63_2: "Cooling provided for industrial or manufacturing processes, such as data centres or pharmaceutical production; it requires the Energy Consumption baseline method in iECM.",
    row64_1: "Proposed",
    row64_2: "The recommended new solution being evaluated against the baseline.",
    row65_1: "Proxy Chiller",
    row65_2: "A Carrier chiller model selected from the e-CAT library to represent the operating site chiller for performance estimation and calibration.",
    row66_1: "Reconfigure",
    row66_2: "An iECM feature that allows users to manually override the automatic chiller-selection algorithm and assign specific chillers to specific operating periods within a retrofit solution.",
    row67_1: "Reference Chiller",
    row67_2:
      "The chiller selected as the performance benchmark for a given baseline pattern; all power, cooling load, and degradation calculations in that baseline are derived from its specifications.",
    row68_1: "Retrofit",
    row68_2: "The process of upgrading or replacing existing chiller plant equipment with newer, more efficient technology to reduce energy consumption and operating costs.",
    row69_1: "ROI",
    row69_2: "Return on investment; annual savings as a percentage of total investment.",
    row70_1: "RT",
    row70_2: "Refrigeration ton; a unit of cooling capacity.",
    row71_1: "RTh",
    row71_2: "Refrigeration ton-hour; a unit of cooling energy.",
    row72_1: "Tariff Rate",
    row72_2: "The electricity price per kWh charged by the utility; it is entered separately for peak and off-peak periods in the baseline configuration.",
    row73_1: "VFD",
    row73_2: "Variable Frequency Drive; a device that adjusts motor speed to match load.",
    row74_1: "Water-Cooled Chiller",
    row74_2: "A chiller that rejects heat through a condenser water loop connected to cooling towers and is typically more efficient than an air-cooled chiller at full load.",
    row75_1: "WC",
    row75_2: "Water-cooled."
  }
}



// WEBPACK FOOTER //
// ./src/locale/outputFile/en.js